export const allOffersDataSelector = (state) => state.offers.offersData;

// We filter out selectedOffers that dont exist in the offersData here at the source
export const selectedOffersUrnsSelector = (state) => {
  const allOffersData = allOffersDataSelector(state);

  const selectedOffers = state.offers.selectedOffers;
  const filteredOfferNumbers = selectedOffers.filter((offer) => allOffersData.some((data) => data.urn === offer));
  return filteredOfferNumbers;
};

export const selectedOffersDataSelector = (state) => {
  const allOffersData = allOffersDataSelector(state);
  const selectedOffersUrns = selectedOffersUrnsSelector(state);
  return allOffersData.filter(({ urn }) => {
    return selectedOffersUrns.includes(urn);
  });
};

export const availableOffersFilterPanelSelector = (state, results) => {
  const allOffersData = allOffersDataSelector(state);
  const selectedOffersData = selectedOffersDataSelector(state);
  const offersUrnsInResults = [...new Set(results.flatMap((result) => result?.offers))].filter(Boolean);

  const availableOffersInTheResults = allOffersData.filter((item) => offersUrnsInResults.includes(item.urn));

  // If any offer is selected we always show it, then show any offers that exists in the results data
  return [...new Set([...selectedOffersData, ...availableOffersInTheResults])];
};
